import React from 'react';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import {
  TableCell,
  TableRow,
  TableSortLabel
} from '@material-ui/core';
import { headTableCells } from './helpers/headTableCells';


const UnmappedDataTableHeadRow = ({sort, handleRequestSort}) => {
  const {fieldName, sortDirection} = sort;

  return (
    <TableRow>
      {headTableCells.map((cell, index) => {
        if (!cell.display) {
          return null;
        }

        return (
          <TableCell
            key={index}
            className={`min-w-80 ${cell?.align ? cell.align : ''}`}
            width={cell?.width ? cell.width : 'auto'}
          >
            {cell.fieldName ? (
              <TableSortLabel
                active={fieldName === cell.fieldName}
                IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                onClick={(event) => handleRequestSort(event, cell.fieldName)}
              >
                <div dangerouslySetInnerHTML={{__html: cell.title}} />
              </TableSortLabel>
            ) : (
              cell.label
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default UnmappedDataTableHeadRow;
